import { render, staticRenderFns } from "./ResultListItem.vue?vue&type=template&id=84bc7fa8&scoped=true&"
import script from "./ResultListItem.vue?vue&type=script&lang=ts&"
export * from "./ResultListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bc7fa8",
  null
  
)

export default component.exports